import { grayColor } from 'assets/jss/material-dashboard-pro-react';

const placeholderStyles = () => ({
	placeholder: {
		display: 'inline-block',
		minHeight: '1em',
		verticalAlign: 'middle',
		cursor: 'wait',
		backgroundColor: `${grayColor[0]} !important`,
		opacity: 0.4,
		height: '100%',
		borderRadius: '8px',
		'&.btn::before': {
			display: 'inline-block',
			content: '""',
		},
	},
	placeholderXs: {
		minHeight: '0.6em',
	},
	placeholderSm: {
		minHeight: '0.8em',
	},
	placeholderLg: {
		minHeight: '1.2em',
	},
	placeholderGlow: {
		display: 'block',
		width: '100%',
		height: '100%',
		'& $placeholder': {
			animation: '$placeholderGlow 2s ease-in-out infinite',
		},
	},
	'@keyframes placeholderGlow': {
		'50%': {
			opacity: 0.2,
		},
	},
	placeholderWave: {
		maskImage: `linear-gradient(130deg, black 55%, rgba(0, 0, 0, ${1 - 0.2}) 75%, black 95%)`,
		maskSize: '200% 100%',
		animation: '$placeholderWave 2s linear infinite',
	},
	'@keyframes placeholderWave': {
		'100%': {
			maskPosition: '-200% 0%',
		},
	},
	notificationPlaceholder: {
		display: 'flex',
		flexDirection: 'column',
		gap: '24px',
	},
	notification: {
		padding: '8px',
		'& .col8': {
			flex: '0 0 auto',
			width: '66.66666667%',
		},
		'& .col12': {
			flex: '0 0 auto',
			width: '100%',
		},
		'& .topSection': {
			display: 'flex',
			gap: '16px',
			justifyContent: 'center',
		},
		'& .icon': {
			width: '50px',
			height: '50px',
			borderRadius: '100%',
		},
		'& .textWrapper': {
			display: 'flex',
			width: '100%',
			flexDirection: 'column',
			gap: '8px',
		},
		'& .bottomSection': {
			marginTop: '12px',
		},
	},
});

export default placeholderStyles;
